import { Divider, IcInfo, IconButton, Typography } from '@musinsa/mds';
import type { ServiceBoostingPerformance } from '@musinsa/services-curator';
import { BoostingPerformanceInfoBottomSheet } from '../components/BoostingPerformanceInfoBottomSheet';

const StatItem = ({ label, value }: { label: string; value: string }) => (
  <div className="flex items-center justify-between py-1">
    <Typography size="13" weight="regular" colorScheme="black">
      {label}
    </Typography>
    <Typography size="13" weight="regular" colorScheme="black" className="text-right">
      {value}
    </Typography>
  </div>
);

interface BoostingPerformanceSectionProps {
  boostingPerformance?: ServiceBoostingPerformance | null;
}

export const BoostingPerformanceSection = ({
  boostingPerformance,
}: BoostingPerformanceSectionProps) => {
  // 데이터가 없으면 렌더링하지 않음
  if (!boostingPerformance) {
    return null;
  }

  return (
    <div className="bg-white px-4">
      <div className="py-3">
        <Divider variant="line" />
      </div>

      {/* 섹션 제목 */}
      <div className="flex items-center gap-0.5 py-3">
        <Typography size="18" weight="medium" colorScheme="black">
          수수료 부스트 프로모션 실적
        </Typography>
        <BoostingPerformanceInfoBottomSheet>
          <IconButton asChild className="flex" size="size16x16">
            <IcInfo />
          </IconButton>
        </BoostingPerformanceInfoBottomSheet>
      </div>

      <div className="pb-3 pt-1">
        {/* 통계 항목들 */}
        <StatItem label="프로모션 명" value={boostingPerformance.promotionName} />
        <StatItem label="프로모션 기간" value={boostingPerformance.promotionPeriod} />
        <StatItem label="추가 수수료율" value={boostingPerformance.additionalCommissionRate} />
        <StatItem label="프로모션 예상 수익" value={boostingPerformance.expectedBoostingEarnings} />
      </div>
    </div>
  );
};
